import { shipmentGroupByDayService, generalServices } from '@/_services'
import moment from 'moment-timezone'
import * as type from './types'
import fx from 'money'

const actions = {
  setShipmentDaysList ({ commit, rootGetters, dispatch }, { query, pageSize = 100 }) {
    const filters = [
      ...rootGetters['numericsFilters/getNumericValuesQuery'],
      ...rootGetters['refinementListFilters/getRefinementListValuesQuery']
    ]
    const rangeFilters = [
      ...rootGetters['rangesFilters/getRangeValuesQuery']
    ]
    commit(type.REMOVE_SHIPMENTS_GROUPBYDAY_ERRORS)
    commit(type.SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING, { flag: true })
    shipmentGroupByDayService.Shipments({ query, filters, pageSize, rangeFilters })
    .then(({ items, total, ranges }) => {
      commit(type.SET_SHIPMENTS_GROUPBYDAY_LIST, { items })
      // Set last day for infinity scroll
      let lastMetricDate = items[items.length - 1]
      if (lastMetricDate != null) {
        lastMetricDate = moment(lastMetricDate.date).add(1, 'days').utc(true).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }).unix()
      } else {
        lastMetricDate =  moment().add(1, 'days').utc(true).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }).unix()
      }
      commit(type.SET_SHIPMENTS_GROUPBYDAY_LAST_DAY, { lastDay: lastMetricDate })

      dispatch('rangesFilters/setRangeFilterFromResponse', { ranges, previousRangeFilters: rangeFilters }, { root: true })
      commit(type.SET_SHIPMENTS_GROUPBYDAY_TOTAL, { total: items.length })
    })
    .catch((error) => {
      console.error(error)
      commit(type.SET_SHIPMENTS_GROUPBYDAY_ERRORS, { error })
    })
    .finally(() => {
      commit(type.SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING, { flag: false })
    })
  },
  infinityScrollShipmentDaysList ({ commit }, { query, filters, pageSize = 100, lastDay }) {
    commit(type.REMOVE_SHIPMENTS_GROUPBYDAY_ERRORS)
    commit(type.SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING, { flag: true })
    // Change departureFrom to last day
    const index = filters.findIndex(({ type }) => {
      return type === 'DepartureFrom'
    })
    if (index >= 0){
      filters[index].string = [lastDay]
    }
    shipmentGroupByDayService.Shipments({ query, filters, pageSize })
    .then(({ items, total }) => {
      commit(type.UPDATE_SHIPMENTS_GROUPBYDAY_LIST, { items })
      // Set last day for infinity scroll
      if (items.length > 1) {
        let lastMetricDate = items[items.length - 1]
        if (lastMetricDate != null) {
          lastMetricDate = moment(lastMetricDate.date).add(1, 'days').utc(true).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          }).unix()
        } else {
          lastMetricDate =  moment().add(1, 'days').utc(true).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          }).unix()
        }
        commit(type.SET_SHIPMENTS_GROUPBYDAY_LAST_DAY, { lastDay: lastMetricDate })
      }
      commit(type.SET_SHIPMENTS_GROUPBYDAY_TOTAL, { total: items.length })
    })
    .catch((error) => {
      console.error(error)
      commit(type.SET_SHIPMENTS_GROUPBYDAY_ERRORS, { error })
    })
    .finally(() => (commit(type.SET_SHIPMENTS_GROUPBYDAY_IS_FETCHING, { flag: false })))
  },
  removeSelectedShipment({ commit }) {
    commit(type.REMOVE_SELECTED_SHIPMENT)
  },
  setToggleShipment({ commit }, { shipmentID }) {
    commit(type.SET_TOGGLE_SHIPMENT , { shipmentID })
  },
  removeToggleShipment({ commit }, { shipmentID }) {
    commit(type.REMOVE_TOGGLE_SHIPMENT , { shipmentID })
  },
  setToggleDay({ commit }, { date }) {
    commit(type.SET_TOGGLE_DAY , { date })
  },
  removeToggleDay({ commit }, { date }) {
    commit(type.REMOVE_TOGGLE_DAY , { date })
  },
  setSelectedView({ commit }, { view }) {
    commit(type.SET_SELECTED_VIEW, { view })
  },
  setShipmentsGroupByDayLastUrl({ commit }, { url }) {
    commit(type.SET_LAST_URL, { url })
  },
  async updateSelectedShipmentCard({ commit, getters }, { shipment }) {
    let day = getters['getDayByShipmentID'](shipment.id)
    let shipmentInDayIndex = day.shipments.findIndex(({ id }) => id === shipment.id)
    let shipmentInDay = day.shipments[shipmentInDayIndex]
    let sub = 0
    let add = 0
    if (day != null && shipmentInDay != null){
      // Exchange rate during selecting provider
      if (shipmentInDay.pricing) {
        if (shipmentInDay.pricing.price != null) {
          sub = await generalServices.getExchange({
            price: {
              price: shipmentInDay.pricing.price,
              currency: shipmentInDay.pricing.currency
            },
            destinationCurrency: 'EUR'
          })
        }
      }
      if (shipment.pricing != null) {
        if (shipment.pricing.price != null) {
          add = await generalServices.getExchange({
            price: {
              price: shipment.pricing.price,
              currency: shipment.pricing.currency
            },
            destinationCurrency: 'EUR'
          })
        }
      }
      day.metrics.price.price -= sub.price
      day.metrics.price.price += add.price
      day.shipments[shipmentInDayIndex] = {...shipmentInDay, ...shipment}
      commit(type.UPDATE_SELECTED_SHIPMENT_CARD, { shipment, day })
    }
  },
  updateSelectedShipmentCardLabels({ commit }, { shipment, labels }) {
    commit(type.UPDATE_SELECTED_SHIPMENT_CARD_LABELS, { shipment, labels })
  },
  setResetState({ commit }) {
    commit(type.SET_RESET_STATE)
  }
}

export default actions
